import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { IconLibrary } from '@galabid/gb-dashboard/shared/ui'

@Component({
  selector: 'gb-download-card',
  templateUrl: './gb-download-card.component.html',
  styleUrls: ['./gb-download-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbDownloadCardComponent {
  protected readonly IconLibrary = IconLibrary
  @Input() cardName: string = ''
  @Input() cardDescription: string = ''
  @Input() icon: string = 'download'
  @Input() iconLibrary: IconLibrary = IconLibrary.ionic
}
